import React, {useState} from "react";
import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithInput.js";
import MainFeature from "components/features/TwoColWithButton.js";
import Pricing from "components/pricing/TwoPlansWithDurationSwitcher.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndRating.js";
import FAQ from "components/faqs/SingleCol.js";
import GetStarted from "components/cta/GetStarted";
import motionLifeImageSrc from "images/new-ui-imgs/Section 3 Image.png";
import dashboardImg from "images/new-ui-imgs/Dashboard Image.png";
import beforeAfterImg from "images/new-ui-imgs/Before & After.png";
import bgLeft from "images/new-ui-imgs/Section 4 BG.png";
import bgBlueRight from "images/new-ui-imgs/bgBlueRightMAILogo.png";
import bgFull from "images/new-ui-imgs/bgBlueIllusion.png";

import BodyScanIcon1 from "images/new-ui-imgs/body-scan-icon (1).png";
import BodyScanIcon2 from "images/new-ui-imgs/body-scan-icon (2).png";
import BodyScanIcon3 from "images/new-ui-imgs/body-scan-icon (3).png";
import BodyScanIcon4 from "images/new-ui-imgs/body-scan-icon (4).png";
import BodyScanIcon5 from "images/new-ui-imgs/body-scan-icon (5).png";
import TestimonialIcon from "images/new-ui-imgs/testimonial.png";
// import Footer from "./components/footers/FiveColumnWithInputForm";
import {SectionHeading} from "./components/misc/Headings";
import {SectionDescription} from "./components/misc/Typography";
import {PrimaryButton as PrimaryButtonBase} from "./components/misc/Buttons";
import styled from "styled-components";
import NewFooter from "./components/footers/NewFooter";
import RegistrationForm from "./components/forms/RegistrationForm";
import {useNavigate} from "react-router-dom";
import {Modal} from "react-responsive-modal";

import MAIMotionVideo from "videos/MAIMotion.mp4"
import LandingPageVideo from "./components/LandingPageVideo";

const Heading = tw(SectionHeading)`w-full`;
const HeaderContainer = styled.div(({ bgColor }) => [
    tw`w-full flex flex-col items-center md:px-8 px-3 relative z-20 pb-20`,
    bgColor && `background-color: ${bgColor};`,
]);const Subheading2 = tw.span`font-bold text-secondary-500`;

const ListItem = styled.li`
    ${tw`flex items-baseline text-secondary-100 mb-2`}
    img {
        ${tw`mr-2`}
    }`;

const HighlightedText = tw.span`text-primary-500`;
const Description = styled(SectionDescription)(props => [
    tw`w-full`,
    props.isLeft ? tw`text-left` : tw`text-center`,
]);
const PrimaryButton = styled(PrimaryButtonBase)(props => [
    tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
    props.buttonRounded && tw`rounded-full`
]);
const ThreeColumnContainer = styled.div`
    ${tw`mt-10 flex flex-col items-center md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto w-full`}
`;
const Column = styled.div`
    ${tw`md:w-1/2 lg:w-1/3 max-w-xs md:p-2 py-4 px-0`}
`;
const BorderBox = styled.div(({isRight}) => [
    tw`p-4 rounded-xl  bg-white shadow-md mt-5`,
    isRight ? tw`border border-primary-500 text-primary-500` : tw`border`
]);

const WhiteBoxWithIcon = styled.div(({isRight}) => [
    tw`p-4 rounded-xl bg-white shadow-md h-full m-2`,
    `min-height: 220px;`
]);


export const Container = tw.div`relative py-20`;

const BackgroundWrapper = styled.div`position: relative;
    width: 100%;
    overflow: hidden;
    //margin: 40px 0px;

    .bg-full {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        z-index: 0;
    }

    .left-img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        object-fit: cover;
    }

    @media (max-width: 768px) {
        .left-img {
            position: static;
            width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
    .right-img {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .content {
        position: relative;
        z-index: 2;
    }
`;

export default () => {
    const [openModal, setOpenModal] = useState(false);
    const [openVideoModal, setOpenVideoModal] = useState(false);
    const navigate = useNavigate()
    return (
        <AnimationRevealPage isLanding>
            <Hero roundedHeaderButton={true} onClick={() => setOpenModal(true)}/>
            <LandingPageVideo setOpenVideoModal={setOpenVideoModal} />
            <Container>
                <HeaderContainer>
                    <Heading>
                        Feel Better. Move Freely.
                        <br/>Live Without Limits.
                    </Heading>
                    <Description>Discover how our cutting-edge AI system helps you move better, feel stronger, and stay
                        pain-free—starting with just one scan.</Description>
                    <PrimaryButton buttonRounded onClick={() => setOpenModal(true)}>
                        SCAN NOW FOR FREE
                    </PrimaryButton>
                </HeaderContainer>
            </Container>
            <HeaderContainer bgColor="#131E47">
                <MainFeature
                    subheading=""
                    heading={<>
                        <HighlightedText>Feel the difference in how you move </HighlightedText> and live, starting now.
                    </>}
                    imageSrc={motionLifeImageSrc}
                    imageBorder={false}
                    imageDecoratorBlob={false}
                    primaryButtonText="SCAN NOW FOR FREE"
                    description="You don’t need to travel or book time off. With the MAI Motion app, you can complete your full body scan from home—just by recording simple videos on your phone."
                    subdescription={
                    <>
                        <p>
                            It’s quick. It’s accurate. And it could change how you move and feel—starting today.
                        </p>
                        <br />
                        <p>
                            Sign up now to get your access link, scan instructions, and personalised motion report.
                        </p>
                        <br />
                        <p>
                            No gear. No guesswork. Just real answers, in your hands.
                        </p>
                        <br />
                        <p>
                            Decode your movement.
                        </p>
                    </>}
                    textOnLeft={false}
                    color="white"
                    onClick={() => setOpenModal(true)}
                />
            </HeaderContainer>

            <BackgroundWrapper>
                {/* Left-side Image */}
                <img className="left-img" src={bgLeft} alt="Left Side"/>
                <HeaderContainer>
                    <MainFeature
                        subheading=""
                        imageSrc={null}
                        heading={<>
                            Struggling With Stiffness, <HighlightedText>Aches or Bad Posture? </HighlightedText>
                        </>}
                        imageBorder={false}
                        imageDecoratorBlob={false}
                        primaryButtonText="SCAN NOW FOR FREE"
                        columnReverse
                        onClick={() => setOpenModal(true)}
                        description={<>
                            <Subheading2>
                                Here’s Why It’s Not Your Fault.
                            </Subheading2>
                            <p>
                                You’ve tried stretching. You’ve seen a physio. You may even work out regularly.
                            </p>
                            <p>
                                But the pain comes back.
                            </p>
                            <p> You still feel tight, unbalanced, or like something’s “off.”
                            </p>
                        </>}
                        subdescription={
                            <>
                                <Subheading2>
                                    That’s because most people are guessing.
                                </Subheading2>
                                <div style={{marginTop: 15}}>
                                    <ul>
                                        <ListItem>
                                            <img src={require("images/new-ui-imgs/check.png")}/>
                                            Guessing what’s wrong.
                                        </ListItem>
                                        <ListItem>
                                            <img src={require("images/new-ui-imgs/check.png")}/>
                                            Guessing what’s working.
                                        </ListItem>
                                        <ListItem>
                                            <img src={require("images/new-ui-imgs/check.png")}/>
                                            Guessing how to get better.
                                        </ListItem>
                                        <ListItem>
                                            <img src={require("images/new-ui-imgs/check.png")}/>
                                            MAI Motion ends the guesswork. For good.
                                        </ListItem>
                                    </ul>

                                </div>

                            </>

                        }
                        textOnLeft
                    />
                </HeaderContainer>
            </BackgroundWrapper>

            <Container>
                <HeaderContainer style={{ paddingBottom: 0 }}>
                    <Heading>
                        What Is <HighlightedText>MAI Motion?</HighlightedText>
                    </Heading>
                    <Description>MAI Motion is a smart, non-invasive body scan that shows how you move, where you’re out
                        of balance, and what’s causing pain or poor posture.</Description>

                    <Description>We use advanced technology to track your body in real time, and then give you simple,
                        clear steps to improve.</Description>

                    <img src={dashboardImg} alt="Left Side Image" style={{marginTop: 50}}/>

                    <Subheading2>No wires. No gear. No confusion. Just real answers.</Subheading2>

                </HeaderContainer>
            </Container>

            <Container>
                <HeaderContainer>
                    <Heading>
                        How You’ll Feel – Before vs After
                    </Heading>
                    <Description>
                        MAI Motion is a smart, non-invasive body scan that shows how you move, where you’re out
                        of balance, and what’s causing pain or poor posture.
                    </Description>
                    <ThreeColumnContainer>
                        <Column>
                            <Subheading2>Before MAI Motion</Subheading2>
                            <BorderBox>
                                <ul>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/close.png")} alt="close"/>
                                        Tired of pain with no clear cause
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/close.png")} alt="close"/>
                                        Unsure if your exercises are helping
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/close.png")} alt="close"/>
                                        Sitting or standing with poor posture
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/close.png")} alt="close"/>
                                        Frustrated by slow progress
                                    </ListItem>
                                </ul>
                            </BorderBox>
                        </Column>
                        <Column>
                            <img src={beforeAfterImg} alt="Before vs After" style={{height: 380}}/>
                        </Column>
                        <Column>
                            <Subheading2><HighlightedText>After MAI Motion</HighlightedText></Subheading2>
                            <BorderBox isRight>
                                <ul>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/check.png")} alt="check"/>
                                        Clear answers about what’s going wrong
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/check.png")} alt="check"/>
                                        A personalised plan to move better
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/check.png")} alt="check"/>
                                        Better posture and less pain, day by day
                                    </ListItem>
                                    <ListItem>
                                        <img src={require("images/new-ui-imgs/check.png")} alt="check"/>
                                        Confidence knowing you’re on the right track
                                    </ListItem>
                                </ul>
                            </BorderBox>
                        </Column>
                    </ThreeColumnContainer>
                </HeaderContainer>
            </Container>

            <BackgroundWrapper style={{background: "#131E47", paddingTop: 50}}>
                {/* Left-side Image */}
                <img className="right-img" src={bgBlueRight} alt="Right Side"/>
                <div style={{padding: "50px 0px"}}>
                    <HeaderContainer>
                        <Heading style={{ color: "white" }}>
                            What’s Included in <HighlightedText>Your First BODY MOT Scan? </HighlightedText>

                        </Heading>

                        <ThreeColumnContainer>
                            <Column>
                                <WhiteBoxWithIcon>
                                    <img src={BodyScanIcon1} alt="Body Scan" style={{marginBottom: 15}}/>
                                    <Subheading2>
                                        Real-Time Movement Tracking
                                    </Subheading2>
                                    <Description isLeft>
                                        See exactly how your body moves as you walk, bend, and stretch
                                    </Description>
                                </WhiteBoxWithIcon>
                            </Column>
                            <Column>
                                <WhiteBoxWithIcon>
                                    <img src={BodyScanIcon2} alt="Body Scan" style={{marginBottom: 15}}/>
                                    <Subheading2>
                                        Posture + Balance Check

                                    </Subheading2>
                                    <Description isLeft>
                                        Find out if your posture or movement is putting pressure on your joints
                                    </Description>
                                </WhiteBoxWithIcon>
                            </Column>
                            <Column>
                                <WhiteBoxWithIcon>
                                    <img src={BodyScanIcon3} alt="Body Scan" style={{marginBottom: 15}}/>
                                    <Subheading2>
                                        Personal Plan to Improve
                                    </Subheading2>
                                    <Description isLeft>
                                        Get a simple, custom plan to reduce pain and feel more in control of your body
                                    </Description>
                                </WhiteBoxWithIcon>
                            </Column>
                            <Column>
                                <WhiteBoxWithIcon>
                                    <img src={BodyScanIcon4} alt="Body Scan" style={{marginBottom: 15}}/>
                                    <Subheading2>
                                        Progress You Can Track
                                    </Subheading2>
                                    <Description isLeft>
                                        See how much you’re improving—not just feel it
                                    </Description>
                                </WhiteBoxWithIcon>
                            </Column>
                            <Column>
                                <WhiteBoxWithIcon>
                                    <img src={BodyScanIcon5} alt="Body Scan" style={{marginBottom: 15}}/>
                                    <Subheading2>
                                        No Gear or Guesswork
                                    </Subheading2>
                                    <Description isLeft>
                                        No straps, no sensors, no confusing results. Just walk in and start.
                                    </Description>
                                </WhiteBoxWithIcon>
                            </Column>
                        </ThreeColumnContainer>
                    </HeaderContainer>
                </div>
            </BackgroundWrapper>

            <Container style={{ paddingBottom: 0 }}>
                <HeaderContainer style={{ paddingBottom: 0 }}>
                    <Heading>
                        What happens after my <HighlightedText>Body MOT Scan?</HighlightedText>
                    </Heading>
                    <div style={{marginTop: 15}}>
                        <ul>
                            <ListItem style={{marginBottom: 10}}>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Strategic Reverse Aging plan
                            </ListItem>
                            <ListItem style={{marginBottom: 10}}>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Exercise and movements guidance
                            </ListItem>
                            <ListItem>
                                <img src={require("images/new-ui-imgs/check.png")}/>
                                Check and improve your Body MOT score and physical age
                            </ListItem>

                        </ul>

                    </div>

                </HeaderContainer>
            </Container>


            <Container style={{ paddingTop: 0 }}>
                <HeaderContainer>
                    <Pricing
                        description="Find the perfect plan for your needs by comparing the features included in each. Whether you're an individual patient, a doctor managing a practice, or an administrator overseeing a clinic, we have tailored plans to suit your requirements."
                        heading={
                            <>
                                Reasonable & Flexible <HighlightedText>Plans.</HighlightedText>
                            </>
                        }
                    />
                </HeaderContainer>
            </Container>

            <BackgroundWrapper style={{background: "#131E47"}}>
                <img className="bg-full" src={bgFull} alt="Full Bg"/>
                <Container>
                    <HeaderContainer>
                        {/* Full-side Image */}

                        <div>
                            <img src={TestimonialIcon}  alt="testimonial"/>
                        </div>
                        <Testimonial
                            heading={
                                <>
                                    <HighlightedText>Real Results </HighlightedText>
                                    From Real People
                                </>
                            }
                            color="white"
                            testimonials={[
                                {
                                    "stars": 5,
                                    "profileImageSrc": "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80",
                                    "heading": "Pain-Free in Just Weeks!",
                                    "quote": "I found out what was causing my knee pain in minutes. The plan they gave me worked in just a few weeks. I’m now back to walking daily without discomfort.",
                                    "customerName": "Charlotte Hale",
                                },
                                {
                                    "stars": 5,
                                    "profileImageSrc": "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80",
                                    "heading": "Exceptional Recovery with MAI Motion!",
                                    "quote": "After months of guessing and trying random exercises, I finally got a clear explanation. The personalised plan actually worked—my posture improved, and the knee pain is almost gone!",
                                    "customerName": "Adam Cuppy",
                                }
                            ]}
                        />
                    </HeaderContainer>
                </Container>
            </BackgroundWrapper>
            <Container style={{ paddingBottom: 0 }}>
                <HeaderContainer style={{ paddingBottom: 0 }}>
                    <FAQ/>
                </HeaderContainer>
            </Container>
            <Container style={{ paddingBottom: 0 }}>
                <HeaderContainer style={{ paddingBottom: 0 }}>
                    <GetStarted onClick={() => setOpenModal(true)}/>
                </HeaderContainer>
            </Container>
            <NewFooter/>
            {openModal && <RegistrationForm onClose={() => setOpenModal(false)} onSuccess={() => navigate("/thankyou")} />}
            <Modal
                open={openVideoModal}
                onClose={() => setOpenVideoModal(false)}
                center
                styles={{
                    modal: {
                        padding: 0,
                        background: "black",
                        maxWidth: "90%",
                        width: "auto"
                    },
                    closeButton: {
                        background: "white"
                    }
                }}
            >
                <video controls src={MAIMotionVideo} aria-label="Video">
                    <track kind="captions" />
                </video>
            </Modal>
        </AnimationRevealPage>
    );
}
